<template>
  <div class="ibox">
        <div class="ibox-title">
            <h5>Encontre seu perito:</h5>
            <a href="#" class="pull-right como-funciona">Como funciona?
                <span class="tooltips">Preencha os 3 passos de cadastro da sua demanda, aguarde o contato dos Peritos Assistentes interessados e negocie diretamente de forma totalmente gratuita.</span>
            </a>
        </div>
        <div class="ibox-content">
            <form id="formBuscarPerito" action="/demandas" method="post">
                <div id="buscarPeritoWizard" class="row buscarPeritoWizard">
                    <div class="col-md-4">
                        <h5>Passo 1</h5>
                        <span>Especialidade</span>
                        <br>
                        <div class="form-group first">
                            <label>* Área de atuação</label>
                            <select v-model="form.field_id" class="form-control m-b" required>
                                <option :value="null" selected>Selecione</option>
                                <option v-for="field in fields" :key="field.id" :value="field.id">
                                    {{ field.name }}
                                </option>
                            </select>
                        </div>
                        <!--div class="form-group">
                            <label>Especialização #1</label>
                            <input type="text" class="form-control" v-model="form.skills[0]">
                        </div-->
                        <!--div class="form-group">
                            <label>Especialização #2</label>
                            <input type="text" class="form-control" v-model="form.skills[1]">
                        </div-->
                        <!--div class="form-group">
                            <label>Especialização #3</label>
                            <input type="text" class="form-control" v-model="form.skills[2]">
                        </div-->
                        <div class="form-group first" :class="{ 'has-error': !form.bid_type && showValidationErrors }">
                            <label for="bid_type">* A sua demanda é</label>
                            <select name="bid_type"
                                    id="bid_type"
                                    class="form-control"
                                    v-model="form.bid_type"
                                    required
                            >
                                <option :value="null">Selecione</option>
                                <option value="judicial">Judicial</option>
                                <option value="extrajudicial">Extrajudicial</option>
                            </select>
                            <span class="help-block" v-if="!form.bid_type && showValidationErrors">
                                Este campo é obrigatório
                            </span>
                        </div>
                        <div class="form-group first" :class="{ 'has-error': !form.bid_side && showValidationErrors }">
                            <label for="bid_side">* A sua demanda é do lado do(a)</label>
                            <select name="bid_side"
                                    id="bid_side"
                                    class="form-control"
                                    v-model="form.bid_side"
                                    required
                            >
                                <option :value="null">Selecione</option>
                                <option value="empresa">Empresa</option>
                                <option value="empregado">Empregado/Ex-Empregado</option>
                                <option value="pessoafisica">Pessoa Física</option>
                            </select>
                            <span class="help-block" v-if="!form.bid_side && showValidationErrors">
                                Este campo é obrigatório
                            </span>
                        </div>
                        <div class="form-group" :class="{ 'has-error': !form.bid_opener && showValidationErrors }">
                            <label for="bid_opener" class="control-label">
                                * Você que está abrindo a demanda é:
                            </label>
                            <select class="form-control"
                                    type="date"
                                    id="bid_opener"
                                    v-model="form.bid_opener"
                                    required>
                                <option :value="null">Selecione</option>
                                <option value="escritorio_advocacia">Escritório de Advocacia</option>
                                <option value="advogado_autonomo">Advogado Autônomo</option>
                                <option value="rh_empresa">RH da empresa</option>
                                <option value="financeiro_empresa">Financeiro da empresa</option>
                                <option value="autor_reu_do_processo">Autor/réu do processo</option>
                            </select> 
                        </div>
                    </div>
                    <div class="col-md-4">
                        <h5>Passo 2</h5>
                        <span>Localidade</span>
                        <location-form v-model="form.location_id"></location-form>
                        <!--div class="form-group">
                            <label for="location_complement">
                                Complemento / Região / Bairro
                            </label>
                            <input type="text"
                                    class="form-control"
                                    v-model="form.location_complement"
                                    id="location_complement"
                            >
                        </div-->
                        <div class="form-check">
                            <input type="checkbox" v-model="form.can_be_done_remotely" name="can_be_done_remotely" class="form-check-input" id="can_be_done_remotely" value="1">
                            <label class="form-check-label" for="can_be_done_remotely">Minha demanda pode ser realizada de forma remota/digital</label>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <h5>Passo 3</h5>
                        <span>Serviço</span>
                        <br>
                        <div class="form-group first">
                            <label>* Descrição <a class="fa fa-info-circle como-funciona-descricao" href="#">
                                <span class="tooltips" style='color: #337ab7; font-family:"open sans", "Helvetica Neue", Helvetica, Arial, sans-serif; font-size:13px;'>Importante! Quanto mais informações inserir, maior o número de peritos assistentes que entrarão em contato. Recomendamos que descreva o máximo de detalhes sobre a sua demanda para que os peritos assistentes cadastrados sejam localizados e se encaixem no perfil desejado. Exemplo: pleito da demanda, natureza técnica da perícia, prazos (data da perícia), local exato da perícia, qual tipo de trabalho a ser realizado pelo perito assistente etc.</span>
                            </a></label>
                            <textarea v-model="form.description"
                                      class="form-control"
                                      placeholder="Não insira dados de contato, informações pessoais ou que possam lhe identificar. Contratantes que não seguirem essas premissas terão suas demandas excluidas e sua conta penalizada."
                                      rows="5"
                                      v-on:keyup="countDown"
                                      required
                            ></textarea>
                            <span style="color: inherit">{{ countDownText || "0 de 60 caracteres minimos" }}</span>
                        </div>
                        <!--div class="form-group">
                            <label for="bid_estimated_value" class="control-label">
                                Valor Estimado:
                            </label>
                            <select class="form-control"
                                    type="date"
                                    id="bid_estimated_value"
                                    v-model="form.bid_estimated_value">
                                    <option :value="null" selected>Selecione</option>
                                    <option value="R$ 100,00 a R$ 500,00">R$ 100,00 a R$ 500,00</option>
                                    <option value="R$ 500,00 a R$ 1.500,00">R$ 500,00 a R$ 1.500,00</option>
                                    <option value="R$ 1.500,00 a R$ 3.000,00">R$ 1.500,00 a R$ 3.000,00</option>
                                    <option value="R$ 3.000,00 a R$ 5.000,00">R$ 3.000,00 a R$ 5.000,00</option>
                                    <option value="R$ 5.000,00 a R$ 7.000,00">R$ 5.000,00 a R$ 7.000,00</option>
                                    <option value="Acima de R$ 7.000,00">Acima de R$ 7.000,00</option>
                            </select>
                        </div-->
                        <div class="form-group">
                            <label for="bid_docs_input" class="control-label">
                                Anexos:
                            </label>
                            <input class="form-control" id='bid_docs_input' v-on:change="handleAttachments" multiple accept=".pdf,.txt,.doc,.docx,.odt" type="file" />
                        </div>
                        <!--div class="form-group">
                            <label for="bid_complexity" class="control-label">
                                Complexidade:
                            </label>
                            <select class="form-control"
                                    type="date"
                                    id="bid_complexity"
                                    v-model="form.bid_complexity">
                                    <option :value="null" selected>Selecione</option>
                                    <option value="Baixo">Baixo</option>
                                    <option value="Médio">Médio</option>
                                    <option value="Alto">Alto</option>
                            </select> 
                        </div-->
                        <div class="form-group"
                             :class="{ 'has-error': errors.expires_at }"
                        >
                            <label for="expires_at" class="control-label">* Data limite para os orçamentos</label>
                            <input type="date"
                                   name="expires_at"
                                   class="form-control"
                                   v-model="form.expires_at"
                                   id="expires_at"
                                   :min="dateNow"
                                   required
                            >
                            <span class="help-block" v-if="errors.expires_at">
                                {{ errors.expires_at[1] }}
                            </span>
                        </div>
                        <div class="form-group"
                             :class="{ 'has-error': errors.bid_conclusion_date }"
                        >
                            <label for="bid_conclusion_date" class="control-label">* Data limite de Conclusão da Pericia</label>
                            <select class="form-control"
                                    type="date"
                                    id="bid_conclusion_date_flag"
                                    v-model="bid_conclusion_date_flag">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option> 
                            </select>
                            <input v-if="bid_conclusion_date_flag == 1"
                                   type="date"
                                   name="bid_conclusion_date"
                                   class="form-control"
                                   v-model="form.bid_conclusion_date"
                                   id="bid_conclusion_date"
                                   :min="dateNow"
                                   required
                            >
                            <span class="help-block" v-if="errors.bid_conclusion_date">
                                {{ errors.bid_conclusion_date[1] }}
                            </span>
                        </div>
                        <div class="form-group">
                            <label for="inspection_needed" class="control-label">
                                Necessidade de vistoria presencial:
                            </label>
                            <select class="form-control"
                                    type="date"
                                    id="inspection_needed"
                                    v-model="form.inspection_needed">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option> 
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="expert_skills_needed_base" class="control-label">
                                Certificações exigidas do Perito Assistente 
                                <a class="fa fa-info-circle como-funciona-descricao" href="#">
                                    <span class="tooltips" style='color: #337ab7; font-family:"open sans", "Helvetica Neue", Helvetica, Arial, sans-serif; font-size:13px;'>Por exemplo: CRECI, CREA, CRM, etc.</span>
                                </a>
                            </label>
                            <select class="form-control"
                                    type="text"
                                    id="expert_skills_needed_base"
                                    placeholder="CRECI e CREA"
                                    v-model="expert_skills_needed_base">
                                    <option :value="null" selected>Selecione</option>
                                    <option value="Nenhuma">Nenhuma</option>
                                    <option value="CREA">CREA</option>
                                    <option value="CRECI">CRECI</option>
                                    <option value="CRB">CRB</option>
                                    <option value="CRC">CRC</option>
                                    <option value="CRM">CRM</option>
                                    <option value="CRO">CRO</option>
                                    <option value="CRP">CRP</option>
                                    <option value="CREFITO">CREFITO</option>
                                    <option value="CRF">CRF</option>
                                    <option value="COREN">COREN</option>
                                    <option value="OAB">OAB</option>
                                    <option value="Outros">Outros</option>
                            </select>
                            <input  v-if="expert_skills_needed_base == 'Outros'"
                                    class="form-control"
                                    type="text"
                                    id="expert_skills_needed_others"
                                    placeholder="Descreva a certificação necessária"
                                    v-model="expert_skills_needed_others"> 
                            </input>
                        </div>
                        <div class="form-group">
                            <button id="buttonBuscarPerito"
                               :disabled="!isFilled"
                               v-if="!changeElementWhileSending"
                               data-toggle="modal"
                               type="button"
                               @click="createBid"
                               class="btn btn-md btn-primary pull-right m-t-n-xs"
                            >
                                <strong>Buscar Perito</strong>
                            </button>
                            <div
                                v-if="changeElementWhileSending"
                                class="checkoutStatus">
                                <div class="icon processing"></div>
                            </div>
                        </div>
                    </div> <!-- end third column -->
                </div> <!-- end buscarPeritoWizard -->
            </form>
        </div>

        <div class="modal inmodal fade" id="confirmBidModal" tabindex="-1" role="dialog"  aria-hidden="true">
            <div class="modal-dialog modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">
                            <span aria-hidden="true">&times;</span><span class="sr-only">Close</span>
                        </button>
                        <h4 class="modal-title">Buscar Perito</h4>
                    </div>
                    <div class="modal-body">
                        <p>
                            Ao clicar em Confirmar, você irá criar uma demanda
                            de perito assistente. Enviaremos até 8 profissionais
                            que preenchem os requisitos especificados para contato, seleção e contratação
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-white" data-dismiss="modal">
                            Fechar
                        </button>
                        <button
                            type="button"
                            class="btn btn-primary"
                            data-dismiss="modal"
                            @click="onSubmit"
                        >
                                Confirmar
                        </button>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props:{
        mobile_phone:{
            type:String,
            default:null,
        }
    },
    data() {
        return {
            form: {
                field_id: null,
                skills: [],
                location_id: null,
                location_complement: null,
                description: null,
                expires_at: null,
                bid_conclusion_date: null,
                mobile_phone: null,
                can_be_done_remotely:0,
                bid_type:null,
                bid_side:null,
                bid_opener:null,
                //bid_complexity: null,
                inspection_needed: 0
                //bid_estimated_value: null
            },
            bid_docs: null,
            errors: {},
            formIsSending: false,
            fields: [],
            dateNow:null,
            countDownText:"",
            bid_conclusion_date_flag: 0,
            expert_skills_needed_base: null,
            expert_skills_needed_others: ''
        };
    },
    computed: {
        isFilled() {
            if (!this.form.field_id) {
                return false;
            }

            if (!this.form.description) {
                return false;
            }

            if (!this.form.location_id) {
                return false;
            }

            if (!this.form.bid_type) {
                return false;
            }

            if (!this.form.bid_side) {
                return false;
            }

            if (!this.form.bid_opener) {
                return false;
            }
                        
            if (!this.form.expires_at) {
                return false;
            }

            //if (!this.form.bid_complexity) {
            //    return false;
            //}

            //if (!this.form.bid_estimated_value) {
            //    return false;
            //}
            
            if(!this.expert_skills_needed_base == "Outros" && !this.expert_skills_needed_others){
                return false;
            }

            if(!this.form.bid_conclusion_date && this.bid_conclusion_date_flag == 1){
                return false;
            }

            return true;
        },
        changeElementWhileSending() {
            if (this.formIsSending) {
                return true;
            } else {
                return false;
            }
        },
    },
    methods: {
        handleAttachments(e) {  

            this.bid_docs = e.target.files;
            
        },
        onSubmit() {
            if(this.form.description.length >= 60){

                this.formIsSending = true;

                this.form.expert_skills_needed = this.expert_skills_needed_base != 'Outros' ? this.expert_skills_needed_base : this.expert_skills_needed_others;

                axios.post('/demandas', this.form)
                    .then(({data}) => {
                        toastr.success('Sucesso ao criar demanda');
                        
                        if(this.bid_docs != null){

                            let config = {
                                headers: { 
                                    'content-type': 'multipart/form-data' 
                                }
                            };

                            let formData = new FormData();

                            let filesQtt = this.bid_docs.length; 

                            for (let x = 0; x < filesQtt; x++) {
                                formData.append("bid_docs[]", this.bid_docs[x]);
                            } 

                            formData.append('id', data.id);

                            axios.post('/demandas/attachment', formData, config)
                            .then((response) =>  {

                                $('#bid_docs_input').val('');
                                this.bid_docs = null;
                                this.bid_attachments = response.data;

                                toastr.success('Anexo salvo com sucesso');
                            })
                            .catch((err) => {
                                console.log(`Erro ao salvar anexo: ${err}`);
                            });

                        }
                            
                        location.href = 'minhas_demandas';

                    })
                    .catch((error) => {
                        this.formIsSending = false;
                        this.errors = error.response.data.errors;
                        if(this.errors.mobile_phone){
                            toastr.error('Erro ao criar demanda. Seu cadastro está incompleto. Por favor informe seu celular para que você possa criar uma demanda.');
                        } else {
                            toastr.error('Erro ao criar demanda');
                        }
                    });

            } else {
               toastr.error('A descrição deve ter no mínimo 60 caracteres.', 'Descrição curta');
            }

        },
        countDown(){
            this.countDownText = this.form.description.replace(/  +/g, ' ').length+" de 60 caracteres minimos";
        },
        createBid(){
               
            $("#confirmBidModal").modal();

        },
        showBidModal(){

            setTimeout(function() {
                $('#confirmBidModal').modal('toggle');
            }, 500);
             
        }
    },
    mounted() {

        var date_time = new Date();
        date_time.setTime(date_time.getTime() + 86400000);
        this.dateNow = date_time.toISOString().slice(0,10);
        
        if(this.mobile_phone){
            this.form.mobile_phone = this.mobile_phone;
        }

        axios.get('/fields')
            .then(({data}) => {
                this.fields = data;
            });

    }
}
</script>
